import React from 'react';
import { useLocation } from 'react-router-dom';
import Recorder from './Recorder';

/**
 * RecorderOverlay houdt de recorder actief op pagina's buiten /recordings.
 * Op /recordings wordt de recorderkaart inline getoond via RecorderLauncher;
 * hier rendert de Recorder alleen de zwevende indicator-pill (rechtsonder)
 * zolang er een opname of upload actief is. Klikken op de pill navigeert
 * terug naar de actieve opname.
 */
const RecorderOverlay: React.FC = () => {
    const location = useLocation();

    // Op de recordings-pagina wordt de recorder inline getoond via RecorderLauncher
    if (location.pathname === '/recordings') {
        return null;
    }

    return <Recorder variant="floating" />;
};

export default RecorderOverlay;
